import i18n from '@/libs/i18n'

/**
 * admin-api forwards auth-api's message verbatim inside the AuthAPIError code,
 * and auth-api's legacy contract is an English string. Map it back to a
 * localized message; unknown text falls through to the generic error.
 */
enum AuthErrors {
    InternalServerError = 'Unknown internal server error',
    InvalidData = 'Invalid data received',
    InvalidBillPassword = 'Invalid bill password',
    UserExistByEmail = 'User with this email exists',
    UserExistByCodePayerAndManager = 'User with this code exists',
    NoCodePayerForManagerExists = 'Code payer for this manager does not exist',
    ManagerMissing = 'Manager data is missing',
    UserNotConnectedToManager = 'User is not connected to manager'
}

export const parseErrorAuth = (errorMessage: string) => {
    const t = i18n.global.t

    switch (errorMessage as AuthErrors) {
        case AuthErrors.InternalServerError:
            return t('api_errors.internal_server_error')
        case AuthErrors.InvalidData:
            return t('api_errors.invalid_data')
        case AuthErrors.InvalidBillPassword:
            return t('api_errors.invalid_bill_password')
        case AuthErrors.UserExistByEmail:
            return t('api_errors.user_exists_by_email')
        case AuthErrors.UserExistByCodePayerAndManager:
            return t('api_errors.user_exists_by_code_payer')
        case AuthErrors.NoCodePayerForManagerExists:
            return t('api_errors.no_code_payer')
        case AuthErrors.ManagerMissing:
            return t('api_errors.manager_missing')
        case AuthErrors.UserNotConnectedToManager:
            return t('api_errors.user_not_connected_to_manager')
        default:
            return t('errors.generic_error')
    }
}
